import { ConfirmDialog } from '~/components/ConfirmDialog/ConfirmDialog';
import { ContextMenu } from '~/components/ContextMenu/ContextMenu';
import { useDeleteRoundMutation } from '../../mutations';
import { Table } from '~/components/Table/Table';
import { useDialog } from '~/hooks/useDialog';
import { toast } from 'react-toastify';
import { Round } from '~/apis/ssf';

interface Props {
  rounds: Round[];
  isLoading: boolean;
}

function Row({ round }: { round: Round }) {
  const dialog = useDialog();
  const deleteMutation = useDeleteRoundMutation();

  async function handleDelete() {
    await toast.promise(deleteMutation.mutateAsync(round.id), {
      success: 'Serieomgången har tagits bort',
      pending: 'Tar bort serieomgång...',
    });
  }

  return (
    <Table.Row>
      <Table.Col>{round.name}</Table.Col>
      <Table.Col>{round.start}</Table.Col>
      <Table.Col>{round.end}</Table.Col>
      <Table.Col align="right">
        <Table.Context
          items={[
            <ContextMenu.Item label="Redigera" to={`${round.id}/edit`} key="edit" />,
            <ContextMenu.Item label="Ta bort" onClick={dialog.open} key="delete" danger />,
          ]}
        />
      </Table.Col>
      <ConfirmDialog isLoading={deleteMutation.isPending} onConfirm={handleDelete} {...dialog} />
    </Table.Row>
  );
}

export function RoundListTable({ rounds, isLoading }: Props) {
  return (
    <Table bg="even">
      <Table.Head>
        <Table.Row>
          <Table.Col as="th">Namn</Table.Col>
          <Table.Col as="th">Start</Table.Col>
          <Table.Col as="th">Slut</Table.Col>
          <Table.Col as="th" />
        </Table.Row>
      </Table.Head>
      <Table.Body>{isLoading ? <Table.Loading cols={4} /> : rounds.map(r => <Row round={r} key={r.id} />)}</Table.Body>
    </Table>
  );
}
